import request from '@/request'
import store from '@/store'
import CONSTANTS from '@/constants'
const state = {
    myTimelines: [],
}

const mutations = {
    SET_MY_TIME_LINE: (state, myTimelines) => {
        state.myTimelines = myTimelines
    },
}

const actions = {
    setMyTimeline({ commit }, data) {
        commit('SET_MY_TIME_LINE', data)
    },
    setTimeline({ commit }, data) {
        commit('SET_TIME_LINE', data)
    },
    getTimeline({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/keijiban/post',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getTimelineDetail({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/keijiban/show_keijiban_detail',
                method: 'get',
                params: params
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    createTimeline({ commit }, data0) {
        let pointSetting = null
        let slug = null
        return store.dispatch('user/getPointFee', {
            token: store.getters.defaultToken
        }).then(data => {
            
            if (parseInt(store.getters.userDetail.sex) ===CONSTANTS.MALE) {
                slug = "keijiban_post_male"
                // console.log('keijiban_post_male:', data)
            } else {
                slug = "female_post_keijiban"
            }
            pointSetting = data
            let sub_point = pointSetting.result.filter(item => {
                return item.slug === slug && parseInt(item.type) === CONSTANTS.SUB_ACTION_POINT
            })
            if (sub_point[0] && parseInt(pointSetting.balance) >= parseInt(sub_point[0].point)) 
            {
                return new Promise((resolve, reject) => {
                    request({
                        url: '/keijiban/post/create',
                        method: 'post',
                        data: data0
                    }).then(response => {
                        resolve(response)
                    }).catch(error => {
                        resolve(error.response)
                    })
                }) 
            }
            else {
                window.location="/profile/buy-point"
                return -1
            }
        }).catch(err => {
        
        })
      
    },

    deleteTimeline({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/keijiban/delete_keijiban',
                method: 'post',
                data
            }).then(response => {
                store.dispatch('timeline/setMyTimeline', [])
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateTimeline({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/keijiban/edit_keijiban',
                method: 'post',
                data
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    actions,
    mutations,
    state
}